// extracted by mini-css-extract-plugin
export var award = "Rankings-module--award--f5a27";
export var backgroundImage = "Rankings-module--backgroundImage--5139b";
export var backgroundImageHidden = "Rankings-module--backgroundImageHidden--f199b";
export var board = "Rankings-module--board--1af5e";
export var content = "Rankings-module--content--5041d";
export var contentShort = "Rankings-module--contentShort--7cf1d";
export var country = "Rankings-module--country--3eed0";
export var error = "Rankings-module--error--d7786";
export var header = "Rankings-module--header--89288";
export var headerImage = "Rankings-module--headerImage--36652";
export var headerRow = "Rankings-module--headerRow--a632d";
export var heading = "Rankings-module--heading--804bf";
export var moreRankings = "Rankings-module--moreRankings--55bfb";
export var moreRankingsLink = "Rankings-module--moreRankingsLink--18151";
export var moreRankingsWrapper = "Rankings-module--moreRankingsWrapper--61763";
export var name = "Rankings-module--name--ed372";
export var rank = "Rankings-module--rank--45b72";
export var records = "Rankings-module--records--bc7f1";
export var recordsTable = "Rankings-module--recordsTable--32196";
export var recordsWithTopPadding = "Rankings-module--recordsWithTopPadding--358c7";
export var row = "Rankings-module--row--9b54e";
export var score = "Rankings-module--score--4275f";
export var title = "Rankings-module--title--66e10";
export var titleRow = "Rankings-module--titleRow--501ac";
export var winner = "Rankings-module--winner--eb34b";